import { default as pressInit } from "./press.js";
import { submit as recaptchaSubmit, default as recaptchaInit } from "./recaptcha.js";
import { default as tabsInit } from "./tabs.js";
import { default as formsInit } from "./forms.js";
import { page as analyticsPage } from "./analytics.js";
import "./jquery.validate.base.js";
import "./jquery.validate.base.unobtrusive.js";
import "./jquery.validate.regex.js";
import accordion from "./accordion.js";
import { lockout } from "./utilities.js";
import { default as blogSnippetsInit } from "./blog-snippets.js";

const localValues = {
	allow: true,
	fadeClick: true,
	screenWidth: 730,
	backTo: false,
}

const updateVar = (variable, val) => localValues[variable] = val;
const stripTrailingSlash = (str) => str.endsWith('/') ? str.slice(0, -1) : str;


// Event handlers
const addPopupLaunchEvents = () => {
	$('a.js-popup-launch').off('click').on('click', function() {
		const link = $(this);

		if (link.is('.js-popup-launch-close')) {
			close(true, false);
		}

		launch(link.attr('href'), link.attr('data-template') || null);
		return false;
	});
}

const addPopupInjectEvents = () => {
	$('a.js-popup-inject').off('click').on('click', function() {
		const link = $(this);

		if (link.is('.js-popup-inject-close')) {
			close(true, false);
		}

		inject(link.attr('href'), link.attr('data-template') || null);
		return false;
	});
}

const addPopupImageEvents = () => {
	$('a.js-popup-image').off('click').on('click', function() {
		const link = $(this);
		image(link.attr('data-title') || '', link.attr('href'));
		return false;
	});
}

const addPopupGalleryEvents = () => {
	$('a.js-popup-gallery').off('click').on('click', function() {
		const link = $(this);
		const json = link.attr('data-api-url');
		if (json) {
			gallery(json);
		}

		return false;
	});
}

const addPopupShareEvents = () => {
	$('a.js-popup-share').off('click').on('click', function() {
		const link = $(this);
		const title = link.attr('data-title');
		const url = link.attr('data-url');
		const image = link.attr('data-image') || '';

		share(title, url, image);
		return false;
	});
}

const addPopupNewsletterEvents = () => {
	$('.js-newsletter-sign-up').each(function() {
		const wrapper = $(this);
		const form = wrapper.find('form');

		form.off('submit').on('submit', function() {
			if (!form.valid()) {
				return false;
			}

			const email = form.find('.form-text--email').val(),
				url = form.attr('action') + '?email=' + email;

			newsletter(url, email);
			return false;
		});

		// done
		wrapper.addClass('js-newsletter-sign-up-done');
	});
}

const addCloseEvents = () => {
	$('.m-popup .js-close, #popupConfirmNo, .m-photo-gallery__inner').off('click.close').on('click.close', function() {
		close(false, $(this).hasClass('js-close-print'));
		return false;
	});

	window.addEventListener('keydown', function(event) {
		if (event.key === 'Escape') {
			close(false);
		}
	}, { once: true })
}

// Popup Types
const exitFormPopup = (setupFormSubmit) => {
	const url = '/exit-form';

	if (!localValues.allow || window.site.win.width() < localValues.screenWidth || localValues.backTo) {
		location.href = url;
		return false;
	}

	// check if current url
	let comp = url;
	let path = location.pathname;

	comp = stripTrailingSlash(comp)
	path = stripTrailingSlash(path)

	// redirect
	if (comp === path) {
		return false;
	}

	// show loader
	loader();

	// define template
	let template = $('#popupLaunchTemplate').html();
	if (!template) {
		location.href = url;
		return;
	}

	// parse template
	template = Hogan.compile(template);

	// hide open popups
	hideVisiblePopup()

	// get page content
	$.ajax({
		url,
		cache: false,
		success: function(response) {
			const content = $(response).find('#popupContentWrapper').html();
			if (!content) {
				location.href = url;
				return;
			}
			// render template
			const rendered = template.render({
				content,
				url
			});

			// add template to body
			window.site.body.append(rendered);
			// add recaptcha
			recaptchaInit();
			// attach events
			setupFormSubmit(setupFormSubmit);
			// get popup
			const p = $('.m-popup[data-href="' + url + '"]');
			// show
			p.add('#popupFade:hidden').show();

			loader(true, true);
			addCloseEvents()
			analyticsPage(url, 'Popup');
			window.updateDynamicPhoneNumber()
		},
		error: function(e) {
			// hide loader
			loader(true);
			// show notice
			confirm('Error', 'Sorry, the URL "' + url + '" could not be shown (' + e.statusText.toLowerCase() + ').', '', true);
		},
		complete: function() {
			localValues.allow = true;
			localValues.fadeClick = true;
		}
	});
}

const inject = function(url, template) {
	// check if current url
	let comp = url;
	let path = location.pathname;

	comp = stripTrailingSlash(comp)
	path = stripTrailingSlash(path)

	// redirect
	if (comp === path) {
		return false;
	}

	if (!template) {
		template = '#popupLaunchTemplate';
	}

	template = $(template);

	// show loader
	loader();

	// get popup content
	$.ajax({
		url,
		cache: false,
		success: function(response) {
			template.html(response);
			// set top
			template.css('top', getTop());
			// init
			addPopupInjectEvents()
			addCloseEvents()
			// show
			template.add('#popupFade:hidden').show();
			// hide loader
			loader(true, true);
			localValues.allow = true;
			localValues.fadeClick = false;

			window.site.body.append(template);
			accordion();
		},
		error: function(e) {
			// hide loader
			loader(true);
			localValues.allow = true;
			localValues.fadeClick = true;
			// show notice
			confirm('Error', 'Sorry, the URL "' + url + '" could not be shown (' + e.statusText.toLowerCase() + ').', '', true);
		}
	});
}

const launch = function(url, template) {
	const _template = template;
	// allowed check
	if ((!localValues.allow || window.site.win.width() < localValues.screenWidth || localValues.backTo) && url != "/profileform") {

		if (!url || url === '#') {
			location.reload();
			return false;
		}

		location.href = url;
		return false;
	}

	// check if current url
	let comp = url;
	let path = location.pathname;

	comp = stripTrailingSlash(comp)
	path = stripTrailingSlash(path)

	// redirect
	if (comp === path) {
		return false;
	}

	// show loader
	loader();

	// get template
	if (!template) {
		template = '#popupLaunchTemplate';
	}

	template = $(template).html();

	if (!template) {
		location.href = url;
		return;
	}
	// parse template
	template = Hogan.compile(template);

	// hide open popups
	hideVisiblePopup()

	// get page content
	$.ajax({
		url,
		cache: false,
		success: function(response) {
			const content = $(response).find('#popupContentWrapper').html();
			if (!content) {
				location.href = url;
				return;
			}
			// render template
			const rendered = template.render({
				content,
				url
			});
			// add template to body
			window.site.body.append(rendered);
			// get popup
			const p = $('.m-popup[data-href="' + url + '"]');
			// set top
			p.css('top', getTop());
			// init
			addPopupLaunchEvents()
			addCloseEvents()

			// show
			p.add('#popupFade:hidden').show();
			// hide loader
			loader(true, true);
			// analytics
			analyticsPage(url, 'Popup');

			window.updateDynamicPhoneNumber()
			tabsInit();

			if ($('.m-blog-snippets__inner.swiper').length) 
			{
				blogSnippetsInit();
			}
			
			if (_template === '#popupProfileTemplate') {
				import("/js/profile-form.js")
					.then((module) => {
						module.default();
					})
					.catch((err) => console.log(err.message));
			}

			if (url === "/profileform") {
				pressInit()
			}

			recaptchaInit();
			formsInit()
			addPopupFormSubmitEvent();
		},
		error: function(e) {
			// hide loader
			loader(true);
			// show notice
			confirm('Error', 'Sorry, the URL "' + url + '" could not be shown (' + e.statusText.toLowerCase() + ').', '', true);
		},
		complete: function() {
			localValues.allow = true;
			localValues.fadeClick = true;
		}
	});
}

const image = function(title, image) {
	// allowed check
	if (!localValues.allow || localValues.backTo) {
		close();
	}
	localValues.allow = false;

	// get template
	const template = Hogan.compile($('#popupImageTemplate').html());

	// render template
	const rendered = template.render({
		Title: title,
		Image: image
	});
	// add template to body
	window.site.body.append(rendered);

	// get popup
	const p = $('#popupImage');
	// set top
	p.css('top', getTop());

	addPopupImageEvents()
	addCloseEvents()

	// show
	p.add('#popupFade').show();
	// allow popups
	localValues.allow = true;
}

const gallery = function(url) {
	// allowed check
	if (!localValues.allow || localValues.backTo) {
		return false;
	}

	// loader
	loader();
	localValues.allow = false;

	$.ajax({
		url,
		cache: true,
		success: function(responseString) {
			const response = JSON.parse(responseString);

			if (response === null || response.length < 1) {
				// hide loader
				loader(true);
				localValues.allow = true;
				localValues.fadeClick = true;
				return;
			}

			// get images
			const images = [];
			for (let i = 0; i < response.length; i++) {
				const img = response[i];
				images.push({
					Index: i,
					Number: (i + 1),
					Title: img.Alt,
					Description: img.Description,
					ImageUrl: img.Url
				});
			}

			// get template
			const template = Hogan.compile($('#popupGalleryTemplate').html());

			// render template
			const rendered = template.render({
				Images: images,
				Description: response[0].Description,
				Max: response.length
			});

			// add template to body
			window.site.body.append(rendered);

			// get popup
			const p = $('#popupPhotoGallery');
			p.css('top', getTop());
			lockout.on();

			// init
			addPopupGalleryEvents()
			addCloseEvents()

			//Dont close the popup gallery if content is clicked
			$('.m-photo-gallery__content').off('click').on('click', function() {
				return false;
			});

			// Import the photo-gallery here as loading it via critical cant guarantee the template is in place yet with the current setup
			import("/js/photo-gallery.js")
				.then((module) => {
					module.default();
				})
				.catch((err) => console.log(err.message));

			// hide loader
			loader(true);
			// show
			p.add('#popupFade').show();
		},
		error: function(e) {
			// hide loader
			loader(true);
			localValues.fadeClick = true;
			// show notice
			confirm('Error', 'Sorry, the URL "' + url + '" could not be shown (' + e.statusText.toLowerCase() + ').', '', true);
		},
		complete: function() {
			localValues.allow = true;
		}
	})
}

const confirm = function(title, text, url, notice, yesValue, noValue) {
	// allowed check
	if (!localValues.allow || localValues.backTo) {
		close();
	}
	localValues.allow = false;

	// get template
	const template = Hogan.compile($('#popupConfirmTemplate').html());

	const popupTitle = title || 'Confirm';
	if (popupTitle === 'none') {
		popupTitle = '';
	}

	// render template
	const rendered = template.render({
		title: popupTitle,
		text: text || 'Are you sure? This cannot be undone.',
		url,
		isNotice: !notice,
		confirm: yesValue || 'Confirm',
		cancel: noValue || 'Cancel'
	});

	// add template to body
	window.site.body.append(rendered);

	// get popup
	const p = $('#popupConfirm');
	// set top
	p.css('top', getTop());

	addCloseEvents()
	// show
	p.add('#popupFade').show();
	// allow popups
	localValues.allow = true;
}

const share = function(title, url, image) {
	// allowed check
	if (!localValues.allow || localValues.backTo) {
		close();
	}
	localValues.allow = false;

	// get template
	const template = Hogan.compile($('#popupShareTemplate').html());
	// render template
	const rendered = template.render({
		title: encodeURIComponent(title),
		url: encodeURIComponent(url),
		image: encodeURIComponent(image)
	});
	// add template to body
	window.site.body.append(rendered);

	addCloseEvents()
	// get popup
	const p = $('#popupShare');
	// set top
	p.css('top', getTop());
	// show
	p.add('#popupFade').show();
	// allow popups
	localValues.allow = true;
}

const newsletter = function(url, email) {

	// allowed check
	if (!localValues.allow || window.site.win.width() < localValues.screenWidth || localValues.backTo) {
		location.href = url;
		return false;
	}

	// check if current url
	let comp = url;
	let path = location.pathname;

	comp = stripTrailingSlash(comp)
	path = stripTrailingSlash(path)

	// redirect
	if (comp === path) {
		return false;
	}

	// show loader
	loader();

	// define template
	let template = $('#popupLaunchTemplate').html();
	if (!template) {
		location.href = url;
		return;
	}

	// parse template
	template = Hogan.compile(template);

	hideVisiblePopup()

	// get page content
	$.ajax({
		url,
		cache: false,
		success: function(response) {
			const content = $(response).find('#popupContentWrapper').html();

			if (!content) {
				location.href = url;
				return;
			}
			// render template
			const rendered = template.render({
				content: content,
				url
			});

			// add template to body
			window.site.body.append(rendered);
			recaptchaInit();
			// get popup
			const p = $('.m-popup[data-href="' + url + '"]');
			// set top
			p.css('top', getTop());
			// set email
			p.find('.form-text--email').val(email);
			// init
			addPopupNewsletterEvents()
			addPopupFormSubmitEvent()
			addCloseEvents()
			// show
			p.add('#popupFade:hidden').show();
			// hide loader
			loader(true, true);
			// analytics
			analyticsPage(url, 'Popup');
			window.updateDynamicPhoneNumber()
		},
		error: function(e) {
			// hide loader
			loader(true);
			// show notice
			confirm('Error', 'Sorry, the URL "' + url + '" could not be shown (' + e.statusText.toLowerCase() + ').', '', true);
		},
		complete: function() {
			localValues.allow = true;
			localValues.fadeClick = true;
		}
	});
}

const addPopupFormSubmitEvent = function() {
	$('.m-popup form:not(.js-form-done)').each(function() {
		const form = $(this);
		const button = form.find(':submit');

		// submit
		form.on('submit', function() {
			// reset validation
			form.removeData('validator');
			form.removeData('unobtrusiveValidation');
			// validate form
			$.validator.unobtrusive.parse(form);
			// check
			if (form.valid() && recaptchaSubmit) {
				// disable button
				button.addClass('disabled').prop('disabled', true);
				// submit
				$.ajax({
					type: 'POST',
					url: form.attr('action'),
					data: form.serialize(),
					cache: false,
					success: function(response) {
						// remove error
						form.prev('.js-ajax-error:first').remove();
						// check
						if (response.Valid) {
							// close popups
							close();
							// open redirect
							launch(response.Url);
						}
						else {
							localValues.allow = true;
							// add error
							form.before('<p class="form-error js-ajax-error">' + response.Message + '</p>');
						}
					},
					error: function() {
						// remove error
						form.prev('.js-ajax-error:first').remove();
						// add error
						form.before('<p class="form-error js-ajax-error">Sorry, there was an unexpected server error.</p>');
					},
					complete: function() {
						// enable button
						button.removeClass('disabled').prop('disabled', false);
					}
				});
			}

			return false;
		});

		// done
		form.addClass('js-form-done');
	});
}

const loader = function(hide, keepFade, fancy) {
	const p = fancy ? $('#popupLoaderAdv') : $('#popupLoader');
	const f = $('#popupFade');
	localValues.fadeClick = false;

	if (hide) {
		p.hide();
		p.removeClass('show');
		if (!keepFade) {
			f.hide();
		}

		localValues.allow = true;
		return;
	}

	if (localValues.allow) {
		p.addClass('show');
		p.show();
		f.show();
		localValues.allow = false;
	}
}

const hideVisiblePopup = () => {
	// // hide open popups
	const visible = $('.m-popup:visible');
	if (visible.length > 0) {
		// set backto
		localValues.backTo = true;
		// set attr
		visible.hide();
	}
}

const close = function(keepFade, print) {
	const p = $('.m-popup:visible');
	if (!localValues.allow) {
		return;
	}

	localValues.allow = false;

	if (p.is('.m-popup--gallery')) {
		lockout.off();
	}

	// hide loader
	loader(true, true);

	// hide popups
	if (localValues.backTo) {
		localValues.backTo = false;
		$('.m-popup').not(':visible').show();
	}
	else if (!keepFade) {
		// hide fade
		$('#popupFade').hide();
	}

	// remove popup
	p.remove();
	// clear type
	localValues.type = null;
	// trigger print

	if (print) {
		window.print();
	}

	// allow popups
	localValues.allow = true;
	// allow fade click
	localValues.fadeClick = true;
}

const getTop = function() {
	const top = window.site.win.scrollTop();
	const offset = 50;
	return top + offset;
}

const genericPopUpInit = () => {
	$('.popupFade-new').off('click', genericPopUpClose).on('click', genericPopUpClose);
}

const genericPopUpClose = () => {
	$('.popupFade-new').remove();
	$('.m-popup-new').remove();
}

const init = function() {
	addPopupLaunchEvents()
	addPopupInjectEvents()
	addPopupImageEvents()
	addPopupGalleryEvents()
	addPopupShareEvents()
	addPopupNewsletterEvents()

	addCloseEvents()

	// fade click
	$('#popupFade').on('click', function() {
		if (localValues.fadeClick) {
			close(false);
		}

		return false;
	})

	// forms
	addPopupFormSubmitEvent();

	$('a.js-auto-popup-launch').click().removeClass('js-auto-popup-launch');
}

export default init;
export { loader, confirm, localValues as popupsVariables, exitFormPopup, addPopupGalleryEvents, addPopupImageEvents, addCloseEvents, updateVar, close, getTop, genericPopUpInit, genericPopUpClose }
